import { RpcService } from 'rpc';
import { SiteStatus } from '../interfaces';

export interface ISiteService extends RpcService {
	status(): Promise<SiteStatus>;
	chooser(params: { products?: any[] }): Promise<any>;
}

/*
const isSelfStudy = (): boolean => {
	const { course_session } = window.hcstatic;
	const sessionid = course_session && course_session.pk ? course_session.pk : 0;
	return sessionid === 0;
};
*/

export const svc: ISiteService = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@site.rpc`,

	services: {
		status: {
			// cacheable: isSelfStudy(),
			// cacheLifetime: 8,
			parameters: []
		},
		chooser: {
			parameters: [
				{
					name: 'products',
					type: 'array',
					optional: true
				}
			]
		}
	}
}) as ISiteService;

export default svc;
